class SemiGlobal {
  constructor() {
    this.config = {};
  }
}
export default new SemiGlobal();